module.exports = "<doctor-appointments-card\n        ng-repeat=\"data in $ctrl.doctorList track by $index \"\n        doctor=\"data.doctor\"\n        is-sponsored=\"data.isSponsored\"\n        first-day=\"data.firstDay\"\n        second-day=\"data.secondDay\"\n        horary=\"data.horary\"\n        class=\"'mb-2'\"\n        third-day=\"data.thirdDay\"\n        language=\"$ctrl.language\">\n</doctor-appointments-card>"


//////////////////
// WEBPACK FOOTER
// ./~/@front10/healthcare-book/src/app/components/doctor-list/doctor-list.html
// module id = 596
// module chunks = 0